import { gql, useApolloClient } from '@apollo/client'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

export const DRAFT_QUESTIONNAIRE_ID = gql`
  query draftQuestionnaireId($projectId: ID!, $surveyId: ID, $waveId: ID) {
    draftQuestionnaire: draftQuestionnaireV2(
      projectId: $projectId
      surveyId: $surveyId
      waveId: $waveId
    ) {
      questionnaireId
      __typename
    }
  }
`
// TODO: update all the places where QUESTIONNAIRE query is used only for reading questionnaireId
const useDraftQuestionnaireIdCache = (): string => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()
  const client = useApolloClient()

  const queryResult = client.readQuery({
    query: DRAFT_QUESTIONNAIRE_ID,
    variables: {
      projectId,
      surveyId,
      waveId
    }
  })

  return queryResult?.draftQuestionnaire?.questionnaireId ?? ''
}

export default useDraftQuestionnaireIdCache
